import ProgettoCuore from "../";

const routes = [
  {
    name: "ProgettoCuoreListPage",
    path: "/progettocuore",
    component: ProgettoCuore.ProgettoCuoreListPage,
    meta: { title: "Progetto Cuore" },
  },
];

export default routes;
